import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance for location API calls
const locationApi = axios.create({
  baseURL: `${API_BASE_URL}/location/coordinates`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token if available
locationApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Location API methods
export const LocationAPI = {
  // Check if location data exists for organization and application
  checkLocationStatus: async (orgId, appId) => {
    try {
      const response = await locationApi.post('/check', {
        orgId: orgId,
        appId: appId,
      });
      return response.data;
    } catch (error) {
      console.error('Error checking location status:', error);
      throw error;
    }
  },

  // Check location requirement for login flow
  checkLocationRequirement: async (orgId, appId) => {
    try {
      const response = await locationApi.post('/check-requirement', {
        orgId: orgId,
        appId: appId,
      });
      return response.data;
    } catch (error) {
      console.error('Error checking location requirement:', error);
      throw error;
    }
  },

  // Get location data for organization
  getLocation: async (orgId) => {
    try {
      const response = await locationApi.get(`/${orgId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting location data:', error);
      throw error;
    }
  },

  // Submit/save location coordinates
  submitLocation: async (orgId, latitude, longitude) => {
    try {
      const response = await locationApi.post('/submit', {
        orgId: orgId,
        latitude: latitude,
        longitude: longitude,
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting location:', error);
      throw error;
    }
  },

  // Validate coordinates without saving
  validateCoordinates: async (latitude, longitude) => {
    try {
      const response = await locationApi.post('/validate', {
        latitude: latitude,
        longitude: longitude,
      });
      return response.data;
    } catch (error) {
      console.error('Error validating coordinates:', error);
      throw error;
    }
  },

  // Get all locations (admin function)
  getAllLocations: async (filters = {}) => {
    try {
      const response = await locationApi.get('/', {
        params: filters,
      });
      return response.data;
    } catch (error) {
      console.error('Error getting all locations:', error);
      throw error;
    }
  },

  // Delete location data for organization
  deleteLocation: async (orgId) => {
    try {
      const response = await locationApi.delete(`/${orgId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting location:', error);
      throw error;
    }
  },
};

export default LocationAPI;